import { render, staticRenderFns } from "./KpiSkeleton.vue?vue&type=template&id=62e7c18a&scoped=true&"
import script from "./KpiSkeleton.vue?vue&type=script&lang=js&"
export * from "./KpiSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7c18a",
  null
  
)

export default component.exports